<svg xmlns="http://www.w3.org/2000/svg" width="16.971" height="16.971" viewBox="0 0 16.971 16.971">
  <g id="close" transform="translate(159.806 -480.125) rotate(45)">
    <line id="Ligne_1422" data-name="Ligne 1422" x2="20" transform="translate(228.5 452.5)" fill="none" stroke="#3c3c3b" stroke-linecap="round" stroke-width="2"/>
    <line id="Ligne_1423" data-name="Ligne 1423" y2="20" transform="translate(238.5 442.5)" fill="none" stroke="#3c3c3b" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
